module.exports = __webpack_public_path__ + "img/user-avatar.16069ca8.svg";